import React, { useState } from 'react';
import { toast } from 'sonner';
import { Link2, Check } from 'lucide-react';

const SITE_URL = window.location.origin;

const platforms = [
  {
    name: 'WhatsApp',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
    getUrl: (title, url) => `https://api.whatsapp.com/send?text=${encodeURIComponent(`${title} — ${url}`)}`,
    color: 'hover:bg-[#25D366] hover:text-white',
  },
  {
    name: 'Instagram',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
    action: 'copy', // Instagram doesn't support URL sharing — copies caption to clipboard
    color: 'hover:bg-gradient-to-br hover:from-[#F58529] hover:via-[#DD2A7B] hover:to-[#8134AF] hover:text-white',
  },
  {
    name: 'Facebook',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
    getUrl: (title, url) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    color: 'hover:bg-[#1877F2] hover:text-white',
  },
  {
    name: 'X',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-3.5 h-3.5">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
    getUrl: (title, url) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`,
    color: 'hover:bg-[#0f1419] hover:text-white',
  },
  {
    name: 'Pinterest',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12.017 24c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641 0 12.017 0z"/>
      </svg>
    ),
    getUrl: (title, url, imageUrl) => `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(imageUrl || '')}&description=${encodeURIComponent(title)}`,
    color: 'hover:bg-[#E60023] hover:text-white',
  },
];

const ShareButtons = ({ artwork, variant = 'default' }) => {
  const [copied, setCopied] = useState(false);
  if (!artwork) return null;

  const artworkUrl = `${SITE_URL}/artwork/${artwork.id}`;
  const shareTitle = `${artwork.title} — Original painting by Gangadhar Som`;

  const handleShare = async (platform) => {
    if (platform.action === 'copy') {
      // Instagram: copy caption + URL to clipboard
      const caption = `${shareTitle}\n\n${artworkUrl}\n\n#GangadharSom #IndianArt #FineArt #Painting`;
      try {
        await navigator.clipboard.writeText(caption);
        toast.success('Caption copied! Paste it on Instagram');
      } catch {
        toast.error('Failed to copy caption');
      }
      return;
    }
    const url = platform.getUrl(shareTitle, artworkUrl, artwork.image_url);
    window.open(url, '_blank', 'width=600,height=400,noopener,noreferrer');
  };

  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(artworkUrl);
      setCopied(true);
      toast.success('Link copied!');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Failed to copy link');
    }
  };

  // Compact variant for gallery cards
  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-1" data-testid="share-buttons-compact">
        {platforms.map((p) => (
          <button
            key={p.name}
            onClick={(e) => { e.stopPropagation(); handleShare(p); }}
            data-testid={`share-${p.name.toLowerCase()}-compact`}
            className={`p-1.5 bg-white/15 backdrop-blur-sm text-white rounded-full transition-all hover:scale-110 active:scale-95 ${p.color}`}
            title={`Share on ${p.name}`}
          >
            {p.icon}
          </button>
        ))}
        <button
          onClick={handleCopy}
          data-testid="share-copy-link-compact"
          className="p-1.5 bg-white/15 backdrop-blur-sm text-white rounded-full transition-all hover:scale-110 active:scale-95 hover:bg-white/40"
          title="Copy link"
        >
          {copied ? <Check className="w-3.5 h-3.5" /> : <Link2 className="w-3.5 h-3.5" />}
        </button>
      </div>
    );
  }

  // Default variant for modal/detail view
  return (
    <div className="space-y-2" data-testid="share-buttons-default">
      <p className="font-sans uppercase tracking-[0.2em] text-[10px] sm:text-xs text-muted-foreground">Share this artwork</p>
      <div className="flex items-center gap-2">
        {platforms.map((p) => (
          <button
            key={p.name}
            onClick={(e) => { e.stopPropagation(); handleShare(p); }}
            data-testid={`share-${p.name.toLowerCase()}`}
            className={`p-2.5 border border-border bg-card rounded-full transition-all hover:scale-110 active:scale-95 text-muted-foreground ${p.color}`}
            title={`Share on ${p.name}`}
          >
            {p.icon}
          </button>
        ))}
        <button
          onClick={handleCopy}
          data-testid="share-copy-link"
          className={`p-2.5 border border-border bg-card rounded-full transition-all hover:scale-110 active:scale-95 ${copied ? 'bg-green-50 border-green-300 text-green-600' : 'text-muted-foreground hover:bg-muted'}`}
          title="Copy link"
        >
          {copied ? <Check className="w-4 h-4" /> : <Link2 className="w-4 h-4" />}
        </button>
      </div>
    </div>
  );
};

export default ShareButtons;
